import React, { useEffect, useState } from 'react';
import { ConfigType } from '@/types/configType';
import { EnvironmentType } from '@/types/environmentType';
import useConfig from '@/hooks/useConfig';
import { useLocation } from 'react-router-dom';
import { useSpecUrls } from '@/context/SpecUrlsContext';
import SelectBox from '@/components/SelectBox';
import SwaggerLoader from '@/components/SwaggerLoader';
import { first } from 'lodash-es';
import qs from 'qs';
interface SwaggerProps {
  environment: EnvironmentType;
}

function getFirstName(urls: ConfigType[]) {
  return first(urls)?.name ?? '';
}

function Swagger({ environment }: SwaggerProps) {
  const { specUrls, setSpecUrls, getSpecUrl } = useSpecUrls();
  const [name, setName] = useState('');
  const getConfig = useConfig({ type: environment.type, configUrl: environment.configUrl });

  const location = useLocation();
  const [activeSpec, setActiveSpec] = useState<ConfigType>({ url: '', name: '', group: '' });

  const init = async () => {
    const specUrls = await getConfig();
    setSpecUrls(specUrls);

    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
    // String(queryParams['url.primaryName']) 문자열이 "admin/"이런식으로 들어오는데
    // 맨뒤에 "/"제거해줘
    const name: string = queryParams['url.primaryName']
      ? String(queryParams['url.primaryName']).replace(/\/$/, '')
      : getFirstName(specUrls);

    console.log(name);

    setName(`${name}`);
  };

  useEffect(() => {
    init();
  }, [environment, location.search]);

  useEffect(() => {
    const specUrl = getSpecUrl(specUrls, name);
    // console.log(specUrls, name, specUrl);
    if (specUrl) {
      setActiveSpec(specUrl);
    }
  }, [name]);

  return (
    <>
      <SelectBox data={specUrls} name={activeSpec.name} setName={setName} defaultUrl={environment.defaultUrl} />
      {activeSpec.url && (
        <SwaggerLoader type={environment.type} data={activeSpec} defaultUrl={environment.defaultUrl} />
      )}
      {/*<Modal host={currHostName} isVisible={modalState} setModalState={setModalState} />*/}
    </>
  );
}

export default Swagger;
